export default IconDna2Off => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-dna-2-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M17 3v1c-.007 2.46 -.91 4.554 -2.705 6.281m-2.295 1.719c-3.328 1.99 -5 4.662 -5.008 8.014v1" />
  <path d="M17 21.014v-1c0 -1.44 -.315 -2.755 -.932 -3.944m-4.068 -4.07c-1.903 -1.138 -3.263 -2.485 -4.082 -4.068" />
  <path d="M8 4h9" />
  <path d="M7 20h10" />
  <path d="M12 8h4" />
  <path d="M8 16h8" />
  <path d="M3 3l18 18" />
</svg>`;